import { call, put, takeLatest } from "redux-saga/effects";
import { _CALLGETAPI } from "../../api/apiHandler";
import { _API_ENDPOINT, LOCALSESSIONDATAKEYS, SUCCESS } from "../../constants/AppConstants";
import { getLocalSessionData } from "../../utils/Authentication/handleUserSession";
import { handleError } from "../SagaError";
import { GetUserRolesServiceFailure, GetUserRolesServiceInit, GetUserRolesServiceSuccess } from "./UserRolesSlice";
import i18next from "i18next";

function _USERROLESSERVICE(userId, adb2cId){
    const endpoint = _API_ENDPOINT.GET_USER_ROLES;

    const payload = {
          params: {
              'userId': userId,
              'adb2cId': adb2cId
          }
      }

      return _CALLGETAPI(endpoint, payload)
      .then(response => {
          return response;
      })
      .catch((error) => {
          throw error;
      });
}

function* handleUserRoles(){
    try {
        const UID = getLocalSessionData(LOCALSESSIONDATAKEYS.UID);
        const ADB2CID = getLocalSessionData(LOCALSESSIONDATAKEYS.AZURE_AD_B2C_UID);
        const userRoles = yield call(_USERROLESSERVICE(UID, ADB2CID));
        (userRoles.actionStatus.toUpperCase() === SUCCESS)
        ? yield put(GetUserRolesServiceSuccess(userRoles))
        : yield* handleError(GetUserRolesServiceFailure, i18next.t("ERROR_CONTENT.ERR_INFO.TECHNICAL_ERROR"))
    } catch (error){
        yield* handleError(GetUserRolesServiceFailure, error.message);
    }
}

export default function* watchGetUserRolesService() {
    yield takeLatest(GetUserRolesServiceInit.type, handleUserRoles);
}

export {_USERROLESSERVICE}